/* eslint-disable react/no-unescaped-entities */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getPrivacyPolicyInfo } from "./requestCall";
import Markdown from "markdown-to-jsx";
const legalNoticesWrapper = css`
  width: 100%;
  background: #121212;
  color: white;
`;
const legalNotices = (matches) => css`
  width: ${matches ? "calc(100% - 40px)" : "50%"};
  padding: 20px 0;
  margin: 0 ${matches ? "20px" : "auto"};
  .legal-item {
    display: flex;
    flex-direction: column;
    line-height: 30px;
    margin: 30px 0;
    .title {
      font-size: 28px;
      font-weight: bold;
    }
  }
  .legal-item:nth-of-type(1) {
    margin-top: 0;
  }
  .legal-item:nth-last-of-type(1) {
    margin-bottom: 0;
  }
  .legal-item span:nth-of-type(1) {
    font-weight: bold;
  }
  img {
    width: 100%;
  }
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const PrivacyPolicy = () => {
  window.scrollTo(0, 0);
  const matches = useMediaQuery("(max-width: 415px)");
  const [privacyPolicyInfo, setPrivacyPolicyInfo] = useState();
  useEffect(() => {
    getPrivacyPolicyInfo().then((res) => {
      document.title = res?.data?.data?.attributes?.title;
      setPrivacyPolicyInfo(res?.data?.data?.attributes);
    });
  }, []);
  return (
    <div css={legalNoticesWrapper}>
      <div css={() => legalNotices(matches)}>
        <div className="legal-item">
          <span className="title">{privacyPolicyInfo?.title}</span>
        </div>
        <Markdown css={descriptionWrapper}>
          {(process.env.REACT_APP_BASEURL.includes("localhost")
            ? privacyPolicyInfo?.description?.replaceAll(
                "/uploads/",
                `${process.env.REACT_APP_BASEURL}/uploads/`
              )
            : privacyPolicyInfo?.description) || ""}
        </Markdown>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
